import {cleanEntity, diagnosticFetch} from "@mytour/platform";
import type {
  CreateTextDocumentPayload,
  CreateUploadUrlPayload,
  CreateUploadUrlResponse,
  DocumentResponse,
  DownloadUrlResponse,
  FileDocumentResponse,
  PrepareDocumentUploadPayload,
  PrepareDocumentUploadResponse,
  TextDocumentResponse,
  UpdateTextDocumentPayload,
} from "@mytour/shared";
import axios from "axios";

export const documentApiService = {
  async listCustomerDocuments(customerId: string): Promise<DocumentResponse[]> {
    const result = await axios.get<DocumentResponse[]>(`api/customers/${customerId}/documents`);
    return result.data;
  },

  async createTextDocument(payload: CreateTextDocumentPayload): Promise<TextDocumentResponse> {
    const result = await axios.post<TextDocumentResponse>(
      "api/documents/text",
      cleanEntity(payload)
    );
    return result.data;
  },

  async createUploadUrl(payload: CreateUploadUrlPayload): Promise<CreateUploadUrlResponse> {
    const result = await axios.post<CreateUploadUrlResponse>(
      "api/documents/upload-url",
      cleanEntity(payload)
    );
    return result.data;
  },

  async prepareUpload(
    payload: PrepareDocumentUploadPayload
  ): Promise<PrepareDocumentUploadResponse> {
    const result = await axios.post<PrepareDocumentUploadResponse>(
      "api/documents/uploads",
      cleanEntity(payload)
    );
    return result.data;
  },

  async confirmUpload(uploadId: string): Promise<FileDocumentResponse> {
    const result = await axios.post<FileDocumentResponse>(
      `api/documents/uploads/${uploadId}/confirm`
    );
    return result.data;
  },

  async uploadFileToScaleway(
    uploadUrl: string,
    file: File,
    uploadHeaders: Record<string, string> = {"Content-Type": file.type}
  ): Promise<void> {
    await diagnosticFetch(
      uploadUrl,
      {
        method: "PUT",
        body: file,
        headers: uploadHeaders,
      },
      {step: "upload", fileSize: file.size, fileType: file.type}
    );
  },

  async getDownloadUrl(documentId: string): Promise<DownloadUrlResponse> {
    const result = await axios.get<DownloadUrlResponse>(
      `api/documents/${documentId}/download-url`
    );
    return result.data;
  },

  async updateTextDocument(
    documentId: string,
    payload: UpdateTextDocumentPayload
  ): Promise<TextDocumentResponse> {
    const result = await axios.patch<TextDocumentResponse>(
      `api/documents/${documentId}`,
      cleanEntity(payload)
    );
    return result.data;
  },

  async deleteDocument(documentId: string): Promise<void> {
    await axios.delete(`api/documents/${documentId}`);
  },
};
